import { Icon, IconProps } from "./Icon";

export const EyeIcon = (props: IconProps) => {
	return (
		<Icon viewBox="0 0 24 24" fill="none" strokeWidth={2} ariaHidden {...props}>
			<path
				d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<circle cx="12" cy="12" r="3" strokeLinecap="round" strokeLinejoin="round" />
		</Icon>
	);
};
